import { AccountModesEnum } from '@/api';

enum PlanPeriods {
  MONTH = 'month',
  YEAR = 'year',
  UNLIMITED = 'unlimited',
}

const LIMITED_PERIODS: PlanPeriods[] = [PlanPeriods.MONTH, PlanPeriods.YEAR];

const TARIFF_LITE = '';
const TARIFF_PRO = 'pro';
const TARIFF_PRO_PLUS = 'b2b';

enum PlanCategoryEnum {
  LITE = 'lite',
  PRO = 'pro',
  PRO_PLUS = 'proPlus',
}

type TariffType =
  | PlanCategoryEnum.LITE
  | PlanCategoryEnum.PRO
  | PlanCategoryEnum.PRO_PLUS;

const ADDITION_MARK_TO_CATEGORY: Record<string, PlanCategoryEnum> = {
  [TARIFF_LITE]: PlanCategoryEnum.LITE,
  [TARIFF_PRO]: PlanCategoryEnum.PRO,
  [TARIFF_PRO_PLUS]: PlanCategoryEnum.PRO_PLUS,
};

type PlansAvailability = {
  available: PlanCategoryEnum[];
  visible: PlanCategoryEnum[];
};

const MODE_PLANS_AVAILABILITY: Record<AccountModesEnum, PlansAvailability> = {
  [AccountModesEnum.LITE]: {
    available: [PlanCategoryEnum.LITE],
    visible: [PlanCategoryEnum.PRO_PLUS],
  },
  [AccountModesEnum.PRO]: {
    available: [PlanCategoryEnum.PRO],
    visible: [PlanCategoryEnum.PRO_PLUS],
  },
  [AccountModesEnum.PRO_PLUS]: {
    available: [PlanCategoryEnum.PRO_PLUS],
    visible: [],
  },
};

const AI_TRACE_PLANS_AVAILABILITY: PlansAvailability = {
  available: [PlanCategoryEnum.LITE],
  visible: [],
};

// Ai trace only accounts in lite mode are narrowed down to the lite plans they
// can actually buy, so the tabs nav is dropped for them. Pro and pro+ accounts
// keep the plans of their own mode regardless of the ai trace preference.
const getPlansAvailability = (
  accountMode: AccountModesEnum,
  isAiTraceOnly?: boolean,
): PlansAvailability =>
  isAiTraceOnly && accountMode === AccountModesEnum.LITE
    ? AI_TRACE_PLANS_AVAILABILITY
    : MODE_PLANS_AVAILABILITY[accountMode];

type TariffEntity = {
  priority: number;
  title: string;
  slug: PlanCategoryEnum;
  color: string;
  secondaryColor: string;
};

const tariffDisplayData: Record<PlanCategoryEnum, TariffEntity> = {
  [PlanCategoryEnum.LITE]: {
    priority: 1,
    title: 'Personal',
    slug: PlanCategoryEnum.LITE,
    color: '#008D5E',
    secondaryColor: '#D9EEE7',
  },
  [PlanCategoryEnum.PRO]: {
    priority: 2,
    title: 'Pro',
    slug: PlanCategoryEnum.PRO,
    color: '#01359D',
    secondaryColor: '#DAE0EF',
  },
  [PlanCategoryEnum.PRO_PLUS]: {
    priority: 3,
    title: 'Business',
    slug: PlanCategoryEnum.PRO_PLUS,
    color: '#141822',
    secondaryColor: '#F1F3F6',
  },
};

export {
  PlanPeriods,
  LIMITED_PERIODS,
  TARIFF_LITE,
  TARIFF_PRO,
  TARIFF_PRO_PLUS,
  PlanCategoryEnum,
  ADDITION_MARK_TO_CATEGORY,
  MODE_PLANS_AVAILABILITY,
  getPlansAvailability,
  tariffDisplayData,
};

export type { TariffType, PlansAvailability };
